import styled from 'styled-components';
import THEME from "./theme";

export const Wrapper = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    overflow: hidden;
`;

export const Content = styled.div`
    padding: 0 0 120px;
    font-size: ${THEME.FONT.SIZE.SMALL}px;
`;

